import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class EnvService {

  API_URL = environment.api_url;
  IMG_URL = environment.img_url;
  X_STATIC_KEY = environment.x_static_key;

  constructor() { }
}
